import { render, staticRenderFns } from "./NavbarHelp.vue?vue&type=template&id=90864ca0&"
import script from "./NavbarHelp.vue?vue&type=script&lang=js&"
export * from "./NavbarHelp.vue?vue&type=script&lang=js&"
import style0 from "./NavbarHelp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports